export default "__VITE_ASSET__666a382b__"